import type { App } from 'vue';
import FStatus from './f-status.vue';

export declare interface Status {
  install: (app: App) => void;
}

export function useStatus() : Status {
  return {
    install: (app: App) => {
      app.component('FStatus', FStatus);
    },
  };
}